var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.88499 6.23881L5.55036 5.11529L6.66061 6.23881L8.32598 5.11529M1.10938 10.1711L1.83104 7.98028C1.20732 7.04679 0.981693 5.94132 1.1961 4.86942C1.4105 3.79752 2.05034 2.83212 2.99667 2.15273C3.94299 1.47334 5.13139 1.12619 6.34091 1.17581C7.55043 1.22544 8.69876 1.66847 9.57239 2.42254C10.446 3.1766 10.9855 4.19039 11.0905 5.2754C11.1956 6.3604 10.859 7.4428 10.1434 8.32134C9.42779 9.19988 8.38186 9.81477 7.20008 10.0517C6.01829 10.2886 4.78108 10.1314 3.71846 9.60938L1.10938 10.1711Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.0d2efcc485dabae9b395052681000ad9.svg";
export { ForwardRef as ReactComponent };